<template>
    <div>
        <img src="../assets/jidi.jpg" alt="">
        <div class='popContainer'>
            <div class="rollback" @click="rollback()">

            </div>
            <div class="times">
                {{currentTime}}
            </div>
        </div>
        <div class="box">
            <div class="list1">
                <p>姓名</p>
                <div style="border-bottom: 2px solid azure;margin-left: 10px">
                    <spen>{{userList.customerName}}</spen>
                </div>
            </div>
            <div class="list1">
                <p>性别</p>
                <div style="border-bottom: 2px solid azure;margin-left: 10px">
                    <spen v-if="userList.gender==1">男</spen>
                    <spen v-if="userList.gender==2">女</spen>
                </div>
            </div>
            <div class="list1">
                <p>年龄</p>
                <div style="border-bottom: 2px solid azure;margin-left: 10px">
                    <spen>{{userList.age}}</spen>
                </div>
            </div>
            <div class="list1">
                <p>身份证号码</p>
                <div style="border-bottom: 2px solid azure;margin-left: 10px;width: 60%">
                    <spen>{{userList.identityCard}}</spen>
                </div>
            </div>
        </div>
        <div class="box2">
            <div class="list2">
                <p>制作日期</p>
                <div style="border-bottom: 2px solid azure;margin-left: 10px;width: 67%">
                    <spen>{{userList.specimenMakeTime}}</spen>
                </div>
            </div>
            <div class="list2">
                <p>检测样本位置</p>
                <div style="border-bottom: 2px solid azure;margin-left: 10px;width: 56%">
                    <spen style="font-size: 60%;">{{userList.specimenPlace}}</spen>
                </div>
            </div>
            <div class="list2">
                <p>最近一次检测时间</p>
                <div style="border-bottom: 2px solid azure;margin-left: 10px;width: 45%">
                    <spen>{{userList.specimenUseTime}}</spen>
                </div>
            </div>
            <div class="list2">
                <p>管数</p>
                <div style="border-bottom: 2px solid azure;margin-left: 10px;width: 80%">
                    <spen>{{userList.specimenCount}}</spen>
                </div>
            </div>
            <div class="list2">
            </div>

    </div>
        <div class="box3">
            <div class="list3" style="margin-top: 50px">
                <p>制作日期</p>
                <div style="border-bottom: 2px solid azure;margin-left: 10px">
                    <spen>{{userList.makeTime}}</spen>
                </div>
            </div>
            <div class="list3">
                <p>入库日期</p>
                <div style="border-bottom: 2px solid azure;margin-left: 10px">
                    <spen>{{userList.storageTime}}</spen>
                </div>
            </div>
            <div class="list3">
                <p>冷冻位置</p>
                <div style="border-bottom: 2px solid azure;margin-left: 10px">
                    <spen style="font-size: 70%;">{{userList.samplePlaceText}}</spen>
                </div>
            </div>
            <div class="list3">
                <p>细胞数量</p>
                <div style="border-bottom: 2px solid azure;margin-left: 10px;">
                    <spen>{{userList.amount}}</spen>
                </div>
            </div>
            <div class="list3">
                <p>活率</p>
                <div style="border-bottom: 2px solid azure;margin-left: 10px;width: 80%">
                    <spen>{{userList.rate}}</spen>
                </div>
            </div>
            <div class="list3">
                <p>管数</p>
                <div style="border-bottom: 2px solid azure;margin-left: 10px;width: 80%">
                    <spen>{{userList.tubeCount}}</spen>
                </div>
            </div>
            <div class="list3">
                <p>储存年份</p>
                <div style="border-bottom: 2px solid azure;margin-left: 10px;width: 70%">
                    <spen>{{userList.year}}年</spen>
                </div>
            </div>
            <div class="list3">
                <p>操作人</p>
                <div style="border-bottom: 2px solid azure;margin-left: 10px;width: 75%">
                    <spen>{{userList.asdName}}</spen>
                </div>
            </div>
        </div>
        <div class="box4">
            <table >
                <tr>
                    <td width="350">使用日期</td>
                    <td width="100">管数</td>
                    <td width="200">操作人</td>
                </tr>
            </table>
            <div style="height:70%;overflow: auto">
                <table width="350">
                    <spen>{{userList.record}}</spen>
<!--                    <tr v-for="obj in userList.UseRecord">-->
<!--                        <td>{{obj.useTime}}</td>-->
<!--                        <td>{{obj.useNum}}</td>-->
<!--                        <td>{{obj.operator}}</td>-->
<!--                    </tr>-->
                </table>
            </div>
        </div>
        <div class="goBack" @click="rollback()">

        </div>
    </div>
    </div>
</template>

<script>

	export default {
		name: "cell",
		data(){

			return{
				timer: "",
				currentTime: '',
                userList: [
                	{'time':'2012年12月12日','num': 10,'name':'雷迪森'},
	                {'time':'2012年12月19日','num': 19,'name':'李雷'},
	                {'time':'2012年12月18日','num': 17,'name':'韩梅梅'},
	                {'time':'2012年12月12日','num': 10,'name':'雷迪森'},
	                {'time':'2012年12月19日','num': 19,'name':'李雷'},
	                {'time':'2012年12月18日','num': 17,'name':'韩梅梅'},
	                {'time':'2012年12月12日','num': 10,'name':'雷迪森'},
	                {'time':'2012年12月19日','num': 19,'name':'李雷'},
	                {'time':'2012年12月18日','num': 17,'name':'韩梅梅'},
	                {'time':'2012年12月12日','num': 10,'name':'雷迪森'},
	                {'time':'2012年12月19日','num': 19,'name':'李雷'},
	                {'time':'2012年12月18日','num': 17,'name':'韩梅梅'},{'time':'2012年12月12日','num': 10,'name':'雷迪森'},
	                {'time':'2012年12月19日','num': 19,'name':'李雷'},
	                {'time':'2012年12月18日','num': 17,'name':'韩梅梅'},
	                {'time':'2012年12月12日','num': 10,'name':'雷迪森'},
	                {'time':'2012年12月19日','num': 19,'name':'李雷'},
	                {'time':'2012年12月18日','num': 17,'name':'韩梅梅'},{'time':'2012年12月12日','num': 10,'name':'雷迪森'},
	                {'time':'2012年12月19日','num': 19,'name':'李雷'},
	                {'time':'2012年12月18日','num': 17,'name':'韩梅梅'},
	                {'time':'2012年12月12日','num': 10,'name':'雷迪森'},
	                {'time':'2012年12月19日','num': 19,'name':'李雷'},
	                {'time':'2012年12月18日','num': 17,'name':'韩梅梅'},
	                {'time':'2012年12月12日','num': 10,'name':'雷迪森'},
	                {'time':'2012年12月19日','num': 19,'name':'李雷'},
	                {'time':'2012年12月18日','num': 17,'name':'韩梅梅'},
	                {'time':'2012年12月12日','num': 10,'name':'雷迪森'},
	                {'time':'2012年12月19日','num': 19,'name':'李雷'},
	                {'time':'2012年12月18日','num': 17,'name':'韩梅梅'},
	                {'time':'2012年12月12日','num': 10,'name':'雷迪森'},
	                {'time':'2012年12月19日','num': 19,'name':'李雷'},
	                {'time':'2012年12月18日','num': 17,'name':'韩梅梅'},



                ]
			}
		},
		methods: {
			rollback(){
				this.$router.push('/navigation')
			},

		},
		created() {
			var _this = this;
			var times
			_this.userList = JSON.parse(localStorage.getItem('rows'))
			_this.userList.identityCard = _this.userList.identityCard.slice(0,4) + '**********' + _this.userList.identityCard.slice(14,18)
            console.log(_this.userList)
			_this.timer = setInterval(function() {
				let  shi= new Date().getHours()
				let  fen= new Date().getMinutes()
				shi= shi <= 9 ? "0"+ shi : shi
				fen= fen <= 9 ? "0"+ fen : fen
				times =
					new Date().getFullYear() +
					"-" +
					(new Date().getMonth() + 1) +
					"-" +
					new Date().getDate() +
					" " +
					shi +
					":" +
					fen
				_this.currentTime= times
			}, 1000);
			// console.log(_this.currentTime)
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
			}
		}
	}
</script>

<style scoped>
    .goBack{
        width: 20%;
        height: 250px;
        /*background: crimson;*/
        position: absolute;
        top: 76%;
        left: 80%;
        right: 0;
        bottom: 0;
        overflow: hidden;
    }
    .popContainer{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0);
        width: 100%;
        height: 100px;
        color: cornsilk;
        z-index: 100;
    }
    .popContainer .rollback{
        width: 150px;
        height: 100px;
        /*background-color: red;*/
        position: absolute;
        top: 10px;
        left: 20px;
        right: 0;
        bottom: 0;
    }
    .popContainer .times{
        height: 20px;
        position: absolute;
        top: 80%;
        left: 80%;
        right: 0;
        bottom: 0;
    }
    .box{
        width: 20%;
        height: 40%;
        position: absolute;
        top: 45%;
        left: 5%;
        right: 0;
        bottom: 0;
        /*border: 1px solid #7e8c8d;*/
    }
    .box .list1{
        width: 90%;
        height: 30px;
        overflow: hidden;
        margin-top: 50px;
        margin-left: 10%;
        color: white;
        font-size: 20px;
    }
    .list1 p{
        float: left;
    }
    .list1 div{
        height: 25px;
        float: left;
        width: 80%;
    }
    .box2{
        width: 20%;
        height: 40%;
        position: absolute;
        top: 45%;
        left: 28%;
        right: 0;
        bottom: 0;
        /*border: 1px solid #7e8c8d;*/
    }
    .box2 .list2{
        width: 90%;
        height: 30px;
        overflow: hidden;
        margin-top: 50px;
        margin-left: 10%;
        color: white;
        font-size: 20px;
    }
    .list2 p{
        float: left;
    }
    .list2 div{
        height: 25px;
        float: left;
        width: 80%;
    }
    .box3{
        width: 20%;
        height: 40%;
        position: absolute;
        top: 45%;
        left: 52%;
        right: 0;
        bottom: 0;
        /*border: 1px solid #7e8c8d;*/
    }
    .box3 .list3{
        width: 90%;
        height: 30px;
        overflow: hidden;
        margin-top: 30px;
        margin-left: 10%;
        color: white;
        font-size: 20px;
    }
    .list3 p{
        float: left;
    }
    .list3 div{
        height: 25px;
        float: left;
        width: 70%;
    }
    .box4{
        width: 20%;
        height: 43%;
        position: absolute;
        top: 45%;
        left: 75%;
        right: 0;
        bottom: 0;
        /*border: 1px solid #7e8c8d;*/
        color: white;
        font-size: 20px;
        /*overflow:auto;*/
    }
    .box4 tr{
        line-height:                                                                                                                                                                                                          80px
    }
</style>



// WEBPACK FOOTER //
// src/views/client.vue